<template>
  <div class="Box">
    <el-card class="box-card">

      <el-form :model="queryParams" label-position="right" size="medium" label-width="180px" class="mt35">
        <el-row :gutter="35">

          <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20">
            <el-form-item label="免费剧集设置区间："
                          :rules="[
                            { required: true, message: '免费剧集区间不能为空'},
                            { type: 'number', message: '免费剧集区间必须为数字值'}
                          ]"
            >
              <InputNumberRange
                  v-model="queryParams.free_episode_range"
                  :precision="num"
                  placeholder="请输入免费剧集区间"
              ></InputNumberRange>
            </el-form-item>
          </el-col>

          <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="mb20">
            <el-form-item label="单集价格设置区间："
                          :rules="[
                            { required: true, message: '单集价格区间不能为空'},
                            { type: 'number', message: '单集价格区间必须为数字值'}
                          ]"
            >
              <InputNumberRange
                  v-model="queryParams.episode_price_range"
                  :precision="num"
                  placeholder="请输入单集价格区间"
              ></InputNumberRange>
            </el-form-item>
          </el-col>

          <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="mb20">
            <el-form-item label="赠送积分有效天数："
                          :rules="[
                            { required: true, message: '赠送积分有效天数不能为空'},
                            { type: 'number', message: '赠送积分有效天数必须为数字值'}
                          ]">
              <el-input v-model="queryParams.free_balance_days"></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="mb20">
            <el-form-item label="默认免费集数："
                          :rules="[
                            { required: true, message: '默认免费集数不能为空'},
                            { type: 'number', message: '默认免费集数必须为数字值'}
                          ]">
              <el-input v-model="queryParams.episode_price"></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="mb20">
            <el-form-item label="默认单集价格："
                          :rules="[
                            { required: true, message: '默认单集价格不能为空'},
                            { type: 'number', message: '默认单集价格必须为数字值'}
                          ]">
              <el-input v-model="queryParams.free_episode_total"></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="mb20">
            <el-form-item label="头条商品库开关：">
              <el-switch
                  v-model="queryParams.tt_media_link"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-value="1"
                  inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>

<!--          <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="mb20">-->
<!--            <el-form-item label="会员活动：">-->
<!--              <el-input v-model="queryParams.vip_activity"></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->

          <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="mb20">
            <el-form-item label="微信虚拟支付开关：">
              <el-switch
                  v-model="queryParams.virtual_paid_switch"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-value="1"
                  inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>

          <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="mb20">
            <el-form-item label="腾讯商品库开关：">
              <el-switch
                  v-model="queryParams.wx_media_link"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-value="1"
                  inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>

          <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="mb20">
            <el-form-item>
              <el-button type="primary" :loading="loading" @click="onSubmit">保存</el-button>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </el-card>
  </div>
</template>
<script>

import InputNumberRange from '@/components/Input/inputNumberRange.vue'
import {systemEtcApi} from '@/api/SystemConfig/systemEtc';
import {processErrors} from '@/utils/errorHandler';

export default {
  components: {
    InputNumberRange
  },
  data() {
    return {
      num: 0,
      queryParams: {
        free_episode_range: [],
        episode_price_range: [],
        free_balance_days: '',
        tt_media_link: '0',
        vip_activity: '',
        virtual_paid_switch: '0',
        wx_media_link: '0',
      },
      loading: false
    }
  },

  created() {
    this.getSystemEtc()
  },

  methods: {

    /**
     * 获取参数配置
     */
    getSystemEtc() {
      const api = systemEtcApi();
      api.getSystemEtcInfo()
          .then((res) => {
            if (res.code == 0) {
              this.queryParams = res.data;
            } else {
              processErrors(res);
            }
          })
          .catch((error) => {
          });
    },

    onSubmit() {
      this.loading = true;
      let params = this.queryParams;
      params.free_episode_range = params.free_episode_range.join(',');
      params.episode_price_range = params.episode_price_range.join(',');
      const api = systemEtcApi();
      api.editSystemEtcInfo(params)
          .then((res) => {
            if (res.code == 0) {
              this.$message({
                message: '修改成功',
                type: 'success',
              });
              this.loading = false;
              this.getSystemEtc();
            } else {
              processErrors(res);
            }
          })
          .catch((error) => {
          });
    }
  }
}
</script>
<style>
.mb20{
  margin-left: -17.5px !important;
}
</style>
